module.exports = "/fonts/opensansitalic.woff";